<template>
  <div
    @click="openDropdown = true"
    class="row"
    @mouseover="onHover = true"
    @mouseleave="onHover = false"
  >
    <span class="timestamp a-text">{{ item.timestamp }}</span>
    <span class="area a-text">{{ item.area }}</span>
    <span
      :style="{ color: $vuetify.theme.themes.light[color[item.state]] + 'BB' }"
      class="a-text mr-1 name"
      >{{ item.name }}</span
    >
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="description a-text description">{{
          item.description
        }}</span>
      </template>
      <span>{{ item.description }}</span>
    </v-tooltip>
    <span
      class="a-text state"
      :style="{ marginRight: !onHover ? '23px' : '0px' }"
      >{{ item.detailedState }}
    </span>
    <v-menu v-model="openDropdown" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-show="onHover" x-small icon v-bind="attrs" v-on="on">
          <v-icon small>more_vert</v-icon>
        </v-btn>
      </template>
      <div
        @click="$emit('dropdownItem', { mode: dropItem.mode, id: item.plant })"
        class="item"
        v-for="(dropItem, i) in dropdownItems"
        :key="i"
      >
        <div>
          <span class="a-text">
            {{ dropItem.description }}
          </span>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      dropdownItems: [
        { mode: "plant", description: "Planta" },
        { mode: "events", description: "Eventos" },
      ],
      onHover: false,
      openDropdown: "",
      color: ["error", "warning", "accent"],
    };
  },
  data() {
    return {
      dropdownItems: [
        { mode: "plant", description: "Planta" },
        { mode: "events", description: "Eventos" },
      ],
      onHover: false,
      openDropdown: "",
      color: ["error", "warning", "accent"],
    };
  },
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: $light;
  height: 33px;
  border-radius: 5px;
  margin: 3px 10px;
  padding: 0px 0px 0px 10px;
  cursor: pointer;
}
.state {
  width: 100px;
  text-align: end;
}
.timestamp {
  width: 180px;
  text-align: start;
}
.area {
  width: 150px;
  text-align: start;
}
.name {
  width: 100px;
  text-align: start;
}
.description {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}
.item {
  background: white;
  padding: 7px;
}
.item:hover {
  background: $light;
}
</style>